import { Spin } from 'antd';
import { Redirect, Route, Switch } from 'dva/router';
import React, { lazy, Suspense } from 'react';
import mainStyles from './route/main.less';
const Index = lazy(() => import('./route/Index/Index'));
const List = lazy(() => import('./route/List/List'));
const Detail = lazy(() => import('./route/Detail/Detail'));
const Space = lazy(() => import('./route/Space/Space'));
const Recommendation = lazy(() =>
  import('./route/Recommendation/Recommendation')
);
const RecommendForm = lazy(() => import('./route/RecommendForm/RecommendForm'));
const MyRecommend = lazy(() => import('./route/MyRecommend/MyRecommend'));
const Login = lazy(() => import('./route/Login/Login'));
const Article = lazy(() => import('./route/Article/Article'));
const SearchResult = lazy(() => import('./route/SearchResult'));

const Routes = props => {
  return (
    <Suspense
      fallback={
        <div className={mainStyles.pageLoading}>
          <Spin size="large" />
        </div>
      }
    >
      <Switch>
        <Route path="/index" exact component={Index} />
        <Route path="/space" exact component={Space} />
        <Route path="/recommendation" exact component={Recommendation} />
        <Route path="/recommendform" exact component={RecommendForm} />
        <Route path="/my_recommend" exact component={MyRecommend} />
        <Route path="/login" exact component={Login} />
        <Route path="/search_result" exact component={SearchResult} />
        
        <Route path="/news" exact component={List} />
        <Route path="/activity" exact component={List} />
        <Route path="/notice" exact component={List} />
        <Route path="/card" exact component={Article} />
        <Route path="/borrow" exact component={Article} />
        <Route path="/express" exact component={Article} />

        <Route path="/news/detail" component={Detail} />
        <Route path="/activity/detail" component={Detail} />
        <Route path="/notice/detail" component={Detail} />
        <Route path="/space/detail" component={Detail} />
        <Route path="/space/searchDetail" component={Detail} />

        <Redirect from="/" exact to="index" />
      </Switch>
    </Suspense>
  );
};
export default Routes;
